import React from 'react'
import PropTypes from 'prop-types'

const Wallpaper = ({
  backgroundImage,
  clickthroughUrl,
  trackingPixelUrl,
  altText,
  id,
}) => (
  <a
    className="Wallpaper fade-in"
    href={clickthroughUrl}
    style={{
      backgroundImage: `url(${backgroundImage})`,
    }}
    target="_blank"
    rel="noopener noreferrer"
    title={`${altText} (opens in new window)`}
    id={id}
  >
    { trackingPixelUrl && <iframe title={altText} src={trackingPixelUrl} />}
    <style jsx>{`
      .Wallpaper {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        background-position: center top;
        background-repeat: no-repeat;
      }

      iframe {
        width: 1px;
        height: 1px;
        position: absolute;
        bottom: 0;
        left: 0;
      }`}
    </style>
  </a>
)

Wallpaper.propTypes = {
  backgroundImage: PropTypes.string,
  clickthroughUrl: PropTypes.string,
  trackingPixelUrl: PropTypes.string,
  altText: PropTypes.string,
  id: PropTypes.string,
}

Wallpaper.defaultProps = {
  backgroundImage: '',
  clickthroughUrl: '',
  trackingPixelUrl: '',
  altText: '',
  id: '',
}

export default Wallpaper
